// extracted by mini-css-extract-plugin
export default {"itemContainer":"ContactDetailItem_itemContainer__CqqGU","icon":"ContactDetailItem_icon__m5Ul7","detail":"ContactDetailItem_detail__9owsc"};